import { postJsonRequest } from "../../utils/requestHelper";

export const launchMeteringServiceProvider = meteringServiceLaunchProviderOptions => async dispatch => {
  dispatch({ type: "CALL_METERING_SERVICE" });

  let url = process.env.REACT_APP_API_URL + "/api/metering-service/launch-provider";

  try {
    let response = await postJsonRequest(url, meteringServiceLaunchProviderOptions);
    dispatch({ type: 'OPEN_SUCCESS', payload: 'Success calling metering service launch provider !' });
  } catch (error) {
    dispatch({ type: 'OPEN_ERROR', payload: 'Error during calling metering service launch provider !' });    
  }

  dispatch({ type: "METERING_SERVICE_CALL_ENDED" });
};


// WEBPACK FOOTER //
// ./src/actions/Maintenance/MeteringServiceActions.js